module.exports = __webpack_public_path__ + "assets/3b90a18555b1c9bafda3ad3e0c7b38e0.png";